import type { CaseStudy } from '../types';
import { mcdonalds } from './mcdonalds';
import { tsmc } from './tsmc';
import { amazon } from './amazon';
import { nokia } from './nokia';
import { wework } from './wework';
import { ftx } from './ftx';
import { crisis2008 } from './crisis2008';
import { container } from './container';
import { standardOil } from './standardOil';
import { uber } from './uber';
import { aiCoding } from './aiCoding';
import { mixue } from './mixue';
import { stagflation } from './stagflation';
import { opec } from './opec';
import { asianCrisis } from './asianCrisis';
import { transistor } from './transistor';
import { hatchWaxman } from './hatchWaxman';
import { shenzhen } from './shenzhen';
import { taobaoVillage } from './taobaoVillage';

export const cases: CaseStudy[] = [
  mcdonalds,
  tsmc,
  amazon,
  nokia,
  wework,
  ftx,
  crisis2008,
  container,
  standardOil,
  uber,
  aiCoding,
  mixue,
  stagflation,
  opec,
  asianCrisis,
  transistor,
  hatchWaxman,
  shenzhen,
  taobaoVillage,
].sort((a, b) => a.order - b.order);

export const caseMap = new Map(cases.map((item) => [item.id, item]));

export const allNodes = cases.flatMap((item) => item.nodes);
export const nodeMap = new Map(allNodes.map((node) => [node.id, node]));

export function getCase(id: string): CaseStudy | undefined {
  return caseMap.get(id);
}

export function getNode(id: string): (typeof allNodes)[number] | undefined {
  return nodeMap.get(id);
}
